import React from "react";
import { Link } from "react-router-dom";
import { imageUrl, formatPrice } from "@/lib/api";

export default function ArtworkCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`artwork-card-${product.id}`}
      className="flex flex-col gap-4 group cursor-pointer fade-up"
      style={{ animationDelay: `${index * 0.08}s` }}
    >
      <div className="overflow-hidden bg-[#EFEBE6] aspect-[4/5]">
        <img
          src={imageUrl(product.image_path)}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="font-serif text-xl text-[#2D2926] tracking-tight">{product.title}</h3>
        <div className="flex items-center justify-between">
          <span className="text-sm text-[#5B5653]">{product.size}</span>
          <span className="text-sm text-[#2D2926]">{formatPrice(product.price)}</span>
        </div>
      </div>
    </Link>
  );
}
